import React, { useState, useEffect } from "react";
import { getAgents,cloneAgentsFromEnv } from "../../apis/agents";
import {ManageEnvironment} from "./ManageEnvironment";
import { ConfirmDialog } from "../GenericReusableComponents/ConfirmDialog";
import {FormDialog} from "../GenericReusableComponents/FormDialog"
import { updateAgent,deleteAgent,createAgent } from "../../apis/agents";
import { TextInput,AddButton,UpdateButton,SaveAgentConfigButton, DeleteButton,CloneButton,RefreshButton, PortButton, TButton} from "../GenericReusableComponents/HTMLWrappers";
import { Table } from "../GenericReusableComponents/Table";
import { SelectEnvironment,SelectInput } from "../GenericReusableComponents/HTMLWrappers";
import { DeployBot } from "../botsdeployer/DeployBot";
import { ScheduleBot } from "../botsdeployer/ScheduleBot";

import {promoteBotsFromEnv,getBotDeploymentConfigByEnv} from "../../apis/bots"
import { PromoteBots } from "./PromoteBot";
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import DeployIcon from '@mui/icons-material/ArrowForward';
import ScheduleIcon from '@mui/icons-material/AccessTimeFilled';
import SettingsIcon from '@mui/icons-material/Settings';

import ConfigDialog from "../ConfigDialog";

export function AgentManagement() {
  const [agents, setAgents] = useState([]);
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [q, setQ] = useState("");
  const [agentsChanged,setAgentsChanged] = useState(false);
  const [showCreateAgentModal,setShowCreateAgentModal] = useState(false);
  const [showDelAgentModal,setShowDelAgentModal] = useState(false);
  const [showUpdtAgentModal,setShowUpdtAgentModal] = useState(false);
  const [agentTobeDel,setAgentTobeDel] = useState({});
  const [agent,setAgent] = useState({});
  
  const [showAgentConfig,setShowAgentConfig] = useState(false);
  const [showAgentPortConfig,setShowAgentPortConfig] = useState(false);
  const [port, setPort] = useState(getAgentPort());
  const [agentConfig,setAgentConfig] = useState(null);

  const [showManageEnvironment,setShowManageEnvironment] = useState(false);
  const [showEnableDisableAgentConfirmDialog,setShowEnableDisableAgentConfirmDialog] = useState(false);
  const [agentToBeEnabledDisabled, setAgentToBeEnabledDisabled] = useState();
  const [enableDisableAgentConfirmMessage,setEnableDisableAgentConfirmMessage] = useState("");
  const [deleteConfirmMessage,setDeleteConfirmMessage] = useState("");
  const [showCloneAgentsModal,setShowCloneAgentsModal] = useState(false);
  const [selectEnvForCloning,setSelectEnvForCloning] = useState("QA");
  const [selectSourceEnv,setSelectSourceEnv] = useState("DEV");
  const [cloneEnvList,setCloneEnvList] = useState([]);
  const [sourceEnvList,setSourceEnvList] = useState([]);
  const [showDeployBot,setShowDeployBot] = useState(false);
  const [showScheduleBot,setShowScheduleBot] = useState(false);
  const [showLoading,setShowLoading] = useState(false);
  const [showPromoteBots,setShowPromoteBots] = useState(false);
  
  //TODO: to be removed
  const [promoteBotEnvSelected,setPromoteBotEnvSelected] = useState("DEV");
  const [promoteBotButtonLabel,setShowPromoteBotButtonLabel] = useState("");
  const [promoteBotDeploymentProfile,setPromoteBotDeploymentProfile] = useState([]);
  const [promoteBotStatus, setPromotBotsStatus] = useState("");
  // const [addUpdateEnv,setUddUpdateEnv] = useState("DEV")
  const tableColumnsHeader = [
    "Agent ID",
    "Category",
    "Name",
    "Environment",
    "Description",
    "Connection Status",
    "Activity Status",
    "Actions"
  ];

  const envList = [
      {label:"DEV", value:"DEV"},
      {label:"QA", value:"QA"},
      {label:"UAT", value:"UAT"},
      {label:"PROD", value:"PROD"}
    ]
  
  function getTableHeader(){
    return(
      tableColumnsHeader.map(i =>(
        <th>{i}</th>
      ))
    )
  }

  



  useEffect(() => {
    let mounted = true;

   
    if (mounted) {
      setSourceEnvList([...envList]);
      let l = [...envList];
      l.splice(0,1);
      setCloneEnvList(l);
  
    }
    setShowLoading(true);
    getAgents().then((agents) => {
      // console.log("display agents");
      // console.log(JSON.stringify(agents));
      if(Array.isArray(agents)){
        if (mounted) {
          setAgents(agents);
          var fagents = [];
          agents.forEach((x) => fagents.push(x));
          setFilteredAgents(fagents);
          setAgentsChanged(false);
          setShowLoading(false);
        }
      }else{
        setAgents([]);
        setFilteredAgents([]);
        setAgentsChanged(false);
        setShowLoading(false);
      }
    });

    
    return () => (mounted = false);
  }, [agentsChanged]);

  function filterTable(filterString) {
    console.log("Search " + filterString);
    let trimStr = filterString.trim();
    if (trimStr === "") {
      setFilteredAgents(agents);
      setQ("");
      console.log(agents);
    } else {
      setQ(filterString);
      setFilteredAgents(
        agents.filter((agent) => {
          console.log("agent id " + agent.id);
  

          if (agent.agentId.startsWith(filterString)) return true;

          if (agent.enabledStatus.startsWith(filterString)) return true;

          if (agent.environment.startsWith(filterString)) return true;

          if (agent.description.startsWith(filterString)) return true;

          if (agent.agentName.toString().startsWith(filterString)) return true;

          if (agent.category.toString().startsWith(filterString)) return true;
          return false;
        })
      );
    }
  }


  function getAgentPort(){
    return localStorage.getItem('agentPort')
  }

  function setAgentPort(port){
    return localStorage.setItem('agentPort', port)
  }

  function handleOnClickLocalAgentConfig(){
    
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/agent/config', requestOptions)
    .then (async response => {
      const data = await response.text();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
      setAgentConfig(data)
      setShowAgentConfig(true)
    })

    .catch(error => {alert(        alert("Please ensure that your local agent is running")
    )});


  }

  function managePort(){
    setShowAgentPortConfig(true)
  }
   
  function connectAgentPort() {
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json'}
    }

    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/agent/ping', requestOptions)
    .then (async response => {
      const data = await response.text();
      if (!response.ok) 
      {
        const error = (data && data.message) || response.status;
        console.log(error)
        return Promise.reject(error);

      }
      console.log(data)  
    })

    .catch(error => {alert(        alert("Please ensure that your local agent is running on port " + port)
    )});


  }



  function handleOnClickAddAgent(){
    console.log("addAgent");
    setAgent({'environment':'DEV'});
    setShowCreateAgentModal(true);
  }


  function onAgentPortSave(){
    setShowAgentPortConfig(false)
    setAgentPort(port)
    connectAgentPort()

  }

  function onAgentPropSave(){
    setShowAgentConfig(false)
   
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json'},
      body:agentConfig
    }
    console.log("Saving Agent Config")
    fetch('http://localhost:' + localStorage.getItem('agentPort') + '/v1/enterprise/agent/config/' , requestOptions)
    .catch(error => {        alert("Please ensure that your local agent is running")
  });

  }

  function onAgentPropChange(evt){
    setAgentConfig( evt.target.value )

  }

  function onAgentPortChange(evt){
    setPort( evt.target.value )

  }


  function renderAgentPropMapping(){
    return (
      <div>
      <textarea className ='editvalue' rows="20" cols="70" value={agentConfig} onChange={onAgentPropChange}></textarea>

      </div>
    )
  }

  function renderAgentPortNumber(){
    return (
      <div>
      <TextInput tname="Agent Port" 
        tplaceholder={getAgentPort()}
        // tvalue = {getAgentPort()}
        tHandleOnChange={e => onAgentPortChange(e)} />

      </div>
    )
  }




  function onClickDeleteAgent(e, agent) {
    console.log("Delete Agent");
    let message = `Confirm if you to want to delete agent: ${agent.agentName}`;
    setDeleteConfirmMessage(message);
    setAgentTobeDel(agent);
    setShowDelAgentModal(true);
  }

  function handleDeleteAgent(){

    deleteAgent(agentTobeDel,setAgentsChanged);
    
  }

  function onClickEnableDisableAgent(e,agent) {
    
    
    setShowEnableDisableAgentConfirmDialog(true);
    let enableDisableStr = 'enable';
    if(agent.enabledStatus === 'Enabled')
      enableDisableStr = 'disable';
    else
      enableDisableStr = 'enable';
    let message = `Confirm if you to want to ${enableDisableStr} agent: ${agent.agentName}`;
    setEnableDisableAgentConfirmMessage(message);
    setAgentToBeEnabledDisabled(agent);
   

  }

  function handleEnableDisableAgent(){
    console.log("Calling disable Agent");
    let lagent = {...agentToBeEnabledDisabled};
    if(lagent.enabledStatus === 'Enabled')
      lagent.enabledStatus = "Disabled";
    else
      lagent.enabledStatus = "Enabled";
    updateAgent(lagent,setAgentsChanged);
    

  }




  function onClickUpdateAgent(e, agent) {

    console.log(JSON.stringify(agent));
    setAgent(agent);
    setShowUpdtAgentModal(true);
    
  }

  function handleOnClickManageEnv(){
    setShowManageEnvironment(true);
  }

  function onChangeHandler(e){
      let lagent = {...agent}
      if(e.target.name === 'Category'){
        lagent.category = e.target.value
      }

      if(e.target.name === 'Name'){
        lagent.agentName = e.target.value
      }

      if(e.target.name === 'Environment'){
        lagent.environment = e.target.value;
        console.log("setting " + e.target.value)
      }

      if(e.target.name === 'Description'){
        lagent.description = e.target.value
      }
      setAgent(lagent);
  }

  function getFormAddUpdateElements(){
    return(
      <>
      <TextInput tname="Category" 
        tplaceholder = "Enter Agent Category"
        tvalue = {agent.category}
        tHandleOnChange={e => onChangeHandler(e)} />

      <TextInput tname="Name" 
        tplaceholder = "Enter Agent Name"
        tvalue = {agent.agentName}
        tHandleOnChange={e => onChangeHandler(e)} />

      {/* <TextInput tname="Environment" 
        tplaceholder = "Enter Environment"
        tvalue = {agent.environment}
        tHandleOnChange={e => onChangeHandler(e)} /> */}
      
       <SelectInput 
          sname="Environment" 
          svalueList={envList} 
          svalue={agent.environment}
          onChangeHandler={e => onChangeHandler(e)}/>
      
      <TextInput tname="Description" 
        tplaceholder = "Enter Description"
        tvalue = {agent.description}
        tHandleOnChange={e => onChangeHandler(e)} />
      
      </>
    )
  }

  function getActivityStatus(status){
    if(status === undefined){
      return(
        // <span style={{textAlign:'center'}}>
          <>-</>
        // </span>
      )
    }else{
      return status;
    }
  }

  function onClickSaveAgentConfig(){

  }

  function getTableBody(){

    let rowStyle = {color:'gray'};
    
    return filteredAgents.map((agent) => (
      <tr style={agent.enabledStatus === 'Disabled'?rowStyle:{}}>
        <td >{agent.agentId}</td>
        <td>{agent.category}</td>
        <td>{agent.agentName}</td>
        <td>{agent.environment}</td>
        <td>{agent.description}</td>
        <td>
         
            {agent.enabledStatus === 'Disabled'?'-':agent.connectionStatus}
          
        </td>
        <td>
          {agent.enabledStatus === 'Disabled'?'-':getActivityStatus(agent.lockStatus)}
        </td>

        <td>


          <UpdateButton toolTip="Update Agent"
            updateObj={agent}
            onClickHandler={onClickUpdateAgent}/>

          <DeleteButton toolTip="Remove Agent"
            delObj={agent}
            onClickHandler={onClickDeleteAgent}/>

        {/* <SaveAgentConfigButton toolTip="Save To Local Agent Config"
            updateObj={agent}
            onClickHandler={onClickSaveAgentConfig}/> */}

          <button 
            style={{cursor:'pointer'}} 
            onClick={(e) => onClickEnableDisableAgent(e,agent)}>
              {agent.enabledStatus === 'Enabled'? 'Disable': 'Enable'}
          </button>
      
        </td>
      </tr>
    ))
  }

 

  function formSubmitUpdate(){
    updateAgent(agent,setAgentsChanged);
    setAgent({});
  }

  function formSubmitCreate(){
    createAgent(agent,setAgentsChanged);
    setAgent({});
  }

  function getTableActions() {
    return (
      <>
        <RefreshButton onClickHandler={refreshAgents}/>
        <PortButton onClickHandler={managePort}/>

        <TButton 
          toolTip="Local Agent Config" 
          text="Edit Local Agent" 
          onClickHandler={handleOnClickLocalAgentConfig}
          startIcon={<SettingsIcon fontSize="inherit" />}/> 


        <AddButton 
          toolTip="Manage Environments" 
          text="Manage Environments" 
          onClickHandler={handleOnClickManageEnv}/>
        
        <AddButton 
          toolTip="Create New Agent" 
          text="Add Agent" 
          onClickHandler={handleOnClickAddAgent}/>
        
        <CloneButton 
          toolTip="Clone Agents To Other Environments" 
          text="Clone Agents" 
          onClickHandler={handleOnClickCloneAgents}/> 


        <TButton 
          toolTip="Deploy Bots" 
          text="Deploy" 
          onClickHandler={handleOnClickDeployBots}
          startIcon={<DeployIcon fontSize="inherit" />}/> 

        <TButton 
          toolTip="Schedule Bots" 
          text="Schedule" 
          onClickHandler={handleOnClickScheduleBots}
          startIcon={<ScheduleIcon fontSize="inherit" />}/> 

        <TButton 
          toolTip="Promote Bots to Next Environment" 
          text="Promote" 
          onClickHandler={handleOnClickPromoteBots}
          startIcon={<ThumbUpIcon fontSize="inherit" />}/> 

        
        
        
      </>
    );
  }

  function handleOnClickPromoteBots(){
    setShowPromoteBots(true);
  
  }

  function handleOnClickDeployBots(e){
    setShowDeployBot(true);
  }

  function handleOnClickScheduleBots(e){
    setShowScheduleBot(true);
  }


  function refreshAgents(){
    setAgentsChanged(true);
  }

  function handleOnClickCloneAgents(){
    setShowCloneAgentsModal(true);
  }

  
  function handleChangeEnv(e){
    setSelectEnvForCloning(e.target.value);
  }


  function handleChangeEnvSource(e){
    setSelectSourceEnv(e.target.value);
    let lenvList = [...sourceEnvList];
    let i = lenvList.findIndex(i => e.target.value === i.value);
    lenvList.splice(i,1);
    setCloneEnvList(lenvList);
    setSelectEnvForCloning(lenvList[0]);
  }



  
  function getFormElementsForCloneAgentsModal(){
    
    return(
        // <SelectEnvironment selectedEnv={selectEnvForCloning} onChangeHandler={handleChangeEnv}/>
        <>
        <SelectInput 
          sname="Clone Agents from Environment" 
          svalueList={sourceEnvList} 
          svalue={selectSourceEnv} 
          onChangeHandler={handleChangeEnvSource}/>

      

        <SelectInput 
          sname="To Environment" 
          svalueList={cloneEnvList} 
          svalue={selectEnvForCloning} 
          onChangeHandler={handleChangeEnv}/>
      
        </> 
    )
  }

  function formSubmitClone(){
    console.log(`Clone ${selectSourceEnv} Agents to ${selectEnvForCloning}`);
    setShowLoading(true);
    cloneAgentsFromEnv(selectSourceEnv,selectEnvForCloning,onCloneComplete);

  }

  function onCloneComplete(){
    setAgentsChanged(true);
  }





  return (
      <>
     
       
      <Table 
          search={filterTable} 
          tableActions={getTableActions()} 
          columns={getTableHeader()} 
          rows={getTableBody()}
          loading={showLoading}
          />
   
      <FormDialog 
        showDialog={showCreateAgentModal} 
        setShowDialog={setShowCreateAgentModal} 
        formHeader="Create Agent" 
        formElements= {getFormAddUpdateElements()} 
        submitButtonMessage="Create Agent" 
        onFormSubmit={formSubmitCreate}/>
         
      <FormDialog 
        showDialog={showUpdtAgentModal} 
        setShowDialog={setShowUpdtAgentModal} 
        formHeader="Update Agent" 
        formElements= {getFormAddUpdateElements()} 
        submitButtonMessage="Update Agent" 
        onFormSubmit={formSubmitUpdate}/>

      <FormDialog 
        showDialog={showCloneAgentsModal} 
        setShowDialog={setShowCloneAgentsModal} 
        formHeader="Clone Dev Agents" 
        formElements= {getFormElementsForCloneAgentsModal()} 
        submitButtonMessage="Clone" 
        onFormSubmit={formSubmitClone}/>   


        <ConfigDialog
              title={"Agent Config"}
              message={"Set Properties"}
              handleSave={onAgentPropSave}
              open={showAgentConfig}
              setOpen={setShowAgentConfig}
              render={renderAgentPropMapping}
        ></ConfigDialog>


        <ConfigDialog
              title={"Manage Agent Port"}
              message={"Set Agent Port"}
              handleSave={onAgentPortSave}
              open={showAgentPortConfig}
              setOpen={setShowAgentPortConfig}
              render={renderAgentPortNumber}
        ></ConfigDialog>

      <PromoteBots show={showPromoteBots} setShow={setShowPromoteBots}/>

        
      <ConfirmDialog 
        showConfirmDialog={showDelAgentModal} 
        setShowConfirmDialog={setShowDelAgentModal} 
        confirmMessage={deleteConfirmMessage}
        onConfirm={handleDeleteAgent}/>
      
      
      <ManageEnvironment show={showManageEnvironment} setShow={setShowManageEnvironment}/>

      <ConfirmDialog 
        showConfirmDialog={showEnableDisableAgentConfirmDialog} 
        setShowConfirmDialog={setShowEnableDisableAgentConfirmDialog} 
        confirmMessage={enableDisableAgentConfirmMessage}
        onConfirm={handleEnableDisableAgent}/>
        
    

      <DeployBot showDeployBot={showDeployBot} setShowDeployBot={setShowDeployBot}/>

      <ScheduleBot showScheduleBot={showScheduleBot} setShowScheduleBot={setShowScheduleBot}/>
      </>
  );
}
